//============================================================================
// Name        : rfid_print.ts
// Purpose     : Implement regular RFID Print page
// Created     : 2018-07-10

// Copyright   : Copyright 2018 Senitron Corporation. All rights reserved.
//============================================================================

import axios from "axios";
import {InitPage} from "../index";
import Cookies from "js-cookie";
import swal from "sweetalert";

// declare const clientEnableAltSerialForMarkerTags: boolean;

class RfidPrint {
    skipForceSaveEvent = false;
    forceSaveToInventory = true;
    itemNumberField: JQuery<HTMLInputElement>;
    assetIdField: JQuery<HTMLInputElement>;
    storageUnitField: JQuery<HTMLInputElement>;
    altSerialField: JQuery<HTMLInputElement>;
    tagQtyField: JQuery<HTMLInputElement>;
    tagCopyQtyField: JQuery<HTMLInputElement>;
    saveToInventoryCheck: JQuery<HTMLInputElement>;
    itemPriceField: JQuery<HTMLInputElement>;
    foundItemNumber: Number;
    moreDetailsAboutPrintOptions: JQuery<HTMLInputElement>;

    init() {
        this.itemNumberField                = $("#print_job_item_number");
        this.altSerialField                 = $("#print_job_alt_serial");
        this.storageUnitField               = $("#print_job_storage_unit");
        this.tagQtyField                    = $("#print_job_qty");
        this.tagCopyQtyField                = $("#print_job_copies");
        this.saveToInventoryCheck           = $("#print_job_force_save_to_inventory");
        this.itemPriceField                 = $("#print_job_new_price");
        this.moreDetailsAboutPrintOptions   = $("#more_details_about_print_options");

        if(Cookies.get("enable_price_update") === "true"){
            $("input:checkbox[name=enable_price_update]").prop("checked", true);
            $("#advanced_options").collapse("show");
        }

        if(Cookies.get("selected_item") != "" && this.itemNumberField.val() == ""){
            $("#print_job_item_number").val(Cookies.get("selected_item"));
        }

        $("input:checkbox[name=enable_price_update]").on("change", (e) => {
            Cookies.set("enable_price_update", $("#enable_price_update").is(":checked"));
        });

        // Initialize remember reader functionality
        $("#print_job_printer_id").on("change", (e) => {
            axios.get(`save_selected_printer.json`, { params: { id: $(e.target).val() } });
            Cookies.set("selected_item", $("#print_job_item_number").val());
        });

        this.itemNumberField.focus(function(){
            $(this).select();
        });

        this.itemPriceField.focus(function(){
            $(this).select();
        });

        $("#update_price_dialog").on("shown.bs.modal", function() {
            $("#print_job_new_price").focus()
        });

        $("#print_job_force_save_to_inventory").on("click",function(){
            if( ($("#bins").val() != "" && $("#bins").val() != undefined ) || $('#receiving_date_box').is(":checked"))
            {
                $("#print_job_force_save_to_inventory").prop("checked", true);
                $("#print_job_force_save_to_inventory").attr("checked", "checked");

            }
        });

        $("#bins").on("blur",function(e){
            let bins = $(this).val();
            if(bins != "") {
                $("#print_job_force_save_to_inventory").attr("checked", "checked");
                $("#create_zone_base_on_bin").removeAttr("disabled");
            }
            else {
                $("#create_zone_base_on_bin").removeAttr("checked");
                $("#create_zone_base_on_bin").attr("disabled","disabled");

            }

        });

        const _this_temp = this;

        $(".btn_mt_print").on("click",function(e){
            const cdmActive = $("#is_cdm_active").val();
            if (cdmActive == 'true'){
                e.preventDefault();
                let flag = true;
                const markerItemNumber = $("#print_job_item_number").val();
                const countOfTag = $("#print_job_qty").val();
                const serialFrom = $("#print_job_serial_number_from").val();
                const serialTo = $("#print_job_serial_number_to").val();
                let bins = $("#bins").val();
                bins = (typeof bins === "undefined") ? '' : bins;
                const selectedPrinter = $("#print_job_printer_id").val();
                const selectedZone = $("#print_job_sub_zone_id").val();
                const newZone = $("#create_zone_base_on_bin").is(":checked");
                const parameterName = $("#bins").attr("data-message");

                let errorMessage = "";

                if (markerItemNumber == "" || countOfTag == "" ) {
                    errorMessage += "Marker tag item# and count of tags are required \n";
                    flag = false;
                }
                if (selectedPrinter == "") {
                    errorMessage += "The printer is required \n";
                    flag = false;
                }
                if (serialFrom == "" && serialTo == "" ) {
                    errorMessage += "Serial# From and Serial# To should be fill \n";
                    flag = false;
                }
                if (serialFrom != "" && serialTo == "") {
                    errorMessage += "Serial# To should be fill \n";
                    flag = false;
                }
                if (selectedZone == "") {
                    errorMessage += "The Zone is required \n";
                    flag = false;
                }

                if (bins != "") {
                    if(serialTo != "" && serialFrom != "") {
                        const totalTag = ((parseInt(serialTo as string)) - (parseInt(serialFrom as string))) + 1;
                        const arrBins = (bins as string).split("\n");
                        if ( arrBins.length != totalTag) {
                            errorMessage += "Add " + totalTag + " " + parameterName + "(s) \n";
                            flag = false;
                        }
                    }

                }

                if (flag == true) {
                        _this_temp.submitPrint(() => {
                        _this_temp.showSuccess();
                        $(".clean-after").val("");
                        _this_temp.moreDetailsAboutPrintOptions.html("");
                        });
                    return;
                }
                else {
                    swal({
                        title: "Error",
                        text: errorMessage,
                        icon: "error",
                        closeOnClickOutside: false,
                        buttons: {
                        cancel: {
                            text: "Close",
                            value: null,
                            visible: true,
                            className: "sn-btn sn-btn-sm sn-btn-silver",
                            closeModal: true,
                        }
                        },
                        dangerMode: true,
                    });
                    }
            }
            else {
                swal({
                    title: "Error",
                    text: "CDM is not active",
                    icon: "error",
                    closeOnClickOutside: false,
                    buttons: {
                    cancel: {
                        text: "Close",
                        value: null,
                        visible: true,
                        className: "sn-btn sn-btn-sm sn-btn-silver",
                        closeModal: true,
                    }
                    },
                    dangerMode: true,
                });

            }

        });

        $("#print_job_qty, #print_job_item_number, #print_job_serial_number_from, #print_job_serial_number_to ").on('blur',function(){
            _this_temp.set_print_status();
        });

        $('#print_job_printer_id').on('change',function(){
            _this_temp.set_print_status();
        });

        $(window).on("load", function(){
            if($('#select2-print_job_printer_id-container').text() == 'Select Printer')
            {
                $('#cdm_status_text').attr('style','display: none !important');
                $('#cdm_status_icon').removeClass('old-label-success old-label-danger');
                $('#cdm_status_icon').text('');
                $('.cdm_status_extra_text').attr('style','display: none !important');
            }
        });

        $('#print_job_qty').on('blur', (e) => {
            var tagCount = parseInt($('#print_job_qty').val().toString());
            var printThreshold = parseInt($('#print_count_threshold').val().toString());
            if(tagCount >= printThreshold)
            {
                swal({
                    title: 'Are you Sure?',
                    text:  'You have selected to print '+ tagCount +' labels',
                    icon: "warning",
                    closeOnClickOutside: false,
                    className: "sn-m-modal",
                    buttons: {
                      cancel: {
                        text: "Cancel",
                        value: null,
                        visible: true,
                        className: "sn-btn sn-btn-sm sn-btn-silver",
                        closeModal: true
                      },
                      confirm: {
                        text: "Yes",
                        value: true,
                        visible: true,
                        className: "sn-btn sn-btn-sm sn-btn-red",
                        closeModal: true
                      }
                    },
                    dangerMode: true,
                  }).then((willConfirm) => {
                    if (willConfirm) {
                        return true;
                    } else {
                        $('#print_job_qty').focus();
                    }
                  });
            }
        });

        $(".btn_print").on("click", (e) => {
            e.preventDefault();
            const printerSelected = $("#select2-print_job_printer_id-container").text();
            const SelectedItem = $("#print_job_item_number").val();
            if(printerSelected != 'Select Printer'){
                $.ajax({
                    method: "get",
                    dataType: "json",
                    url: 'cdm_status',
                    success: function(response) {
                        var cdmOrIp = `${response.cdm_or_ip}`
                        var cdmActive = `${response.is_online}`
                        if (cdmActive == 'true'){
                            if(SelectedItem != '')
                            {
                                $(e.target).prop("disabled", true);
                                if(cdmOrIp == 'CDM')
                                {
                                    $('#cdm_status_text').attr('style','display: contents !important; vertical-align: middle;');
                                    $('#cdm_status_icon').addClass('old-label-success');
                                    $('#cdm_status_icon').removeClass('old-label-danger');
                                    $('#cdm_status_icon').text('Active');
                                    $('#disable-cdm-error').hide();
                                    $('.cdm_status_extra_text').attr('style','display: contents !important');
                                    $('.cdm_build_text').attr('style','display: contents !important');
                                    $('#time_ago').text(response.time_ago);
                                    if(response.cdm_build)
                                        $('#cdm_build').text('Build date: '+response.cdm_build);
                                    else
                                        $('#cdm_build').text();
                                }
                                else
                                {
                                    $('#cdm_status_text').attr('style','display: none !important');
                                    $('#cdm_status_icon').removeClass('old-label-success old-label-danger');
                                    $('#cdm_status_icon').text('');
                                    $('#disable-cdm-error').hide();
                                    $('.cdm_status_extra_text').attr('style','display: none !important');
                                    $('.cdm_build_text').attr('style','display: none !important');
                                }

                                axios.get(
                                    'check_soft_delete.json', {
                                        params: { query: $('#print_job_item_number').val() }
                                }
                                ).then(({ data }) => {
                                    const printButton = e.target;
                                    const isModalOpen = $("#update_price_dialog").is(":visible");
                                    const enablePriceUpdate = $("#enable_price_update").is(":checked");
                                    if(!enablePriceUpdate || isModalOpen){
                                        _this_temp.submitPrint(() => {
                                            $("#update_price_dialog").modal("hide");
                                            _this_temp.itemNumberField.focus();
                                            _this_temp.showSuccess();
                                            //$(printButton).prop("disabled", false);
                                            $('#btn_print').prop("disabled", false);
                                            $(".clean-after").val("");
                                            $('#print_job_qty').val(1);
                                            _this_temp.moreDetailsAboutPrintOptions.html("");
                                        });
                                        return;
                                    }

                                    axios.get(
                                        "show_item.json", {
                                            params: { query: $('#print_job_item_number').val() }
                                        }
                                    ).then(({ data }) => {
                                        _this_temp.foundItemNumber = data.id;
                                        _this_temp.itemPriceField.val(data.retail_price);
                                        $("#update_price_dialog").modal("show");
                                    }).catch(()=>{
                                        _this_temp.foundItemNumber = null;
                                        _this_temp.showError("Item not found!");
                                    });
                                }).catch(()=>{
                                    _this_temp.foundItemNumber = null;
                                    _this_temp.showError("The print is not permitted because the selected item has been soft-deleted.");
                                });
                            }
                            else
                            {
                                swal({
                                    title: "Error",
                                    text: "Item is not selected",
                                    icon: "error",
                                    closeOnClickOutside: false,
                                    buttons: {
                                    cancel: {
                                        text: "Close",
                                        value: null,
                                        visible: true,
                                        className: "sn-btn sn-btn-sm sn-btn-silver",
                                        closeModal: true,
                                    }
                                    },
                                    dangerMode: true,
                                });
                            }
                        }
                        else {
                            $('#cdm_status_text').attr('style','display: contents !important; vertical-align: middle;');
                            $('#cdm_status_icon').removeClass('old-label-success');
                            $('#cdm_status_icon').addClass('old-label-danger');
                            $('#cdm_status_icon').text('Inactive');
                            $('#disable-cdm-error').show();
                            $('.cdm_status_extra_text').attr('style','display: none !important');
                            $('.cdm_build_text').attr('style','display: none !important');

                            swal({
                                title: "Error",
                                text: "CDM is not active",
                                icon: "error",
                                closeOnClickOutside: false,
                                buttons: {
                                cancel: {
                                    text: "Close",
                                    value: null,
                                    visible: true,
                                    className: "sn-btn sn-btn-sm sn-btn-silver",
                                    closeModal: true,
                                }
                                },
                                dangerMode: true,
                            });
                            e.preventDefault();
                        }
                    }
                });
            } else {
                $('#cdm_status_text').attr('style','display: none !important');
                $('#cdm_status_icon').removeClass('old-label-success old-label-danger');
                $('#cdm_status_icon').text('');
                $('#disable-cdm-error').hide();
                $('.cdm_status_extra_text').attr('style','display: none !important');
                $('.cdm_build_text').attr('style','display: none !important');

                swal({
                    title: "Error",
                    text: "Printer is not selected",
                    icon: "error",
                    closeOnClickOutside: false,
                    buttons: {
                    cancel: {
                        text: "Close",
                        value: null,
                        visible: true,
                        className: "sn-btn sn-btn-sm sn-btn-silver",
                        closeModal: true,
                    }
                    },
                    dangerMode: true,
                });
            }
        });

        this.altSerialField.on("keyup", (e) => {
            const altSerial = $(e.target).val().toString().trim();

            if (altSerial != "") {
                this.configurePrintAltSerial(altSerial);
            }
            else {
                this.configureDefaultPrint();
            }
        });

        this.tagQtyField.on("keyup", (e) => {
            this.updateMoreDetails();
        });

        this.storageUnitField.on("keyup", (e) => {
            const storageUnit = $(e.target).val().toString().trim();

            if (storageUnit != "") {
                this.configurePrintStorageUnit(storageUnit);
            }
            else {
                this.configureDefaultPrint();
            }
            this.updateMoreDetails();
        });

        $('.auto_add_to_inventory').on("input", (e) => {
            const value = $(e.target).val().toString().trim();

            if (value != "") {
                this.saveToInventoryCheck.prop("checked", "checked");
            }

        });

        this.saveToInventoryCheck.on("click", (e) => {
            var autoAddFlag = false;
            $('.auto_add_to_inventory').each(function(){
                if($(this).val() != '')
                    autoAddFlag = true;
            });
            // See if we need to ignore clicks to this
            if (this.skipForceSaveEvent || autoAddFlag) {
                e.preventDefault();
            }

            const val = this.saveToInventoryCheck.is(":checked");

            // Keep track of our save to inventory flag
            this.forceSaveToInventory = val;
            localStorage.setItem("rfid_print_force_save_to_inv", this.forceSaveToInventory.toString());
        });

        this.forceSaveToInventory = localStorage.getItem("rfid_print_force_save_to_inv") == "true";
        if (this.forceSaveToInventory) {
            this.saveToInventoryCheck.prop("checked", "checked");
        }

        this.tagQtyField.val("1");
        this.tagCopyQtyField.val("1");
        setTimeout(() => {
            $("#print_job_item_number").focus();
        }, 1000);

      $('#enable_multiline_alt_serials').on('click', function (e: any) {
        const target = $('#print_job_alt_serial');
        const inputType = e.currentTarget.checked ? 'textarea' : 'input';
        if (inputType === 'input') {
          target.removeAttr('style');
          target.removeAttr('rows');
        }
        const elm = $(document.createElement(inputType));
        target.each(function () {
          $.each(this.attributes, function() {
            elm.attr(this.name, this.value);
          });
        });
        if (inputType === 'textarea') {
          elm.attr('rows', 3);
          elm.attr('style', 'height: auto')
        }
        target.replaceWith(elm);
      });
    }

    set_print_status(){
        const N = $("#print_job_item_number").val();
        const C = $("#print_job_qty").val();
        const P1 = $('#print_job_printer_id option:selected').val();
        const P2 = $('#print_job_printer_id').val();
        const S_From = $("#print_job_serial_number_from").val();
        const S_To = $("#print_job_serial_number_to").val();
        if(N != "" && C != "" && (P1 != "" || P2 != "") && S_From != "" && S_To != "")
            $('#print_btn').removeAttr("disabled");
        else
            $('#print_btn').attr("disabled","disabled");
    }

    configureDefaultPrint() {
        if (this.altSerialField.val() == "" && this.storageUnitField.val() == "") {
            this.skipForceSaveEvent = false;
            this.tagQtyField.prop("readonly", "");
        }
    }

    configurePrintAltSerial(val: string) {
        this.saveToInventoryCheck.prop("checked", "checked");
        this.tagQtyField.prop("readonly", "readonly");
        this.tagQtyField.val("1");

        this.skipForceSaveEvent = true;
    }

    configurePrintStorageUnit(val: string) {
        this.saveToInventoryCheck.prop("checked", "checked");
        // mpz: deactivate and change this feature:
        // this.tagQtyField.prop("readonly", "readonly");
        // this.tagQtyField.val("1");
        this.skipForceSaveEvent = true;
    }

    submitPrint(successCallback) {
        return (<any>$("#rfid_print_form")).ajaxSubmit({
            url: 'print',
            type: "post",
            dataType: "json",
            success: successCallback,
            error: ({responseJSON}) => {
                if (responseJSON) {
                    $("#update_price_dialog").modal("hide");
                    console.log('responseJSON:', responseJSON);
                    this.showError(responseJSON.error);
                } else {
                    // 500 error from server
                    swal('Error(s) in processing:', 'Something went wrong, please contact support', "error", { className: 'swal-blue-color-for-ok' } );
                    return false;
                }

            }
        });
    }

    showError(error) {
        $("#error_sentence").text(error);
        $("#error_box").show();

        setTimeout(() => $("#error_box").hide(), 5000);
    }

    showSuccess() {
        $("#success_box").show();
        setTimeout(() => $("#success_box").hide(), 3000);
    }

    updateMoreDetails() {
        const qty = this.tagQtyField.val() as string;
        let storageUnit = this.storageUnitField.val() as string;
        if (storageUnit == "") { storageUnit = "1"; }
        this.moreDetailsAboutPrintOptions.html(`<span class="bold">Summary:</span> ${qty}\
                                                tags will be printed with QTY ${storageUnit} each = <b>\
                                                ${parseInt(qty, 10) * parseInt(storageUnit, 10)} units</b>`);
        if (!qty) { this.moreDetailsAboutPrintOptions.html(""); }
    }
}

export function LoadPage() {
    InitPage("rfids print", () => {
        const rfid = new RfidPrint();
        rfid.init();
    });

    InitPage("erc pickings", () => {
        const rfid = new RfidPrint();
        rfid.init();
    });
}
